import PaymentContainer from './containers/PaymentContainer';

export const paymentRoutes = [
  {
    path: '/payment',
    component: PaymentContainer,
    key: 'payment',
  },
];
